// components/subscription/PlanComparison.jsx
import React, { useEffect, useState } from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

const PlanComparison = ({ planIds }) => {
  const { comparePlanFeatures, loading, error } = useSubscription();
  const [comparisonData, setComparisonData] = useState(null);

  useEffect(() => {
    const loadComparisonData = async () => {
      try {
        if (planIds && planIds.length > 1) {
          const data = await comparePlanFeatures(planIds);
          setComparisonData(data);
        }
      } catch (err) {
        // Error is handled by the context
      }
    };

    loadComparisonData();
  }, [planIds, comparePlanFeatures]);

  if (loading) return <div className="text-center py-8">Loading comparison...</div>;
  if (error) return <div className="text-center text-red-600 py-8">{error}</div>;
  if (!comparisonData) return <div className="text-center py-8">Select plans to compare</div>;

  const { plans, features } = comparisonData;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Feature
            </th>
            {plans.map(plan => (
              <th key={plan.id} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {plan.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          <tr>
            <td className="px-6 py-4 whitespace-nowrap font-medium">Price</td>
            {plans.map(plan => (
              <td key={plan.id} className="px-6 py-4 whitespace-nowrap">
                ₹{parseFloat(plan.price).toFixed(2)} / {plan.period === 1 ? 'month' : `${plan.period} months`}
              </td>
            ))}
          </tr>
          
          {features.map((feature, index) => (
            <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
              <td className="px-6 py-4 font-medium">{feature.name}</td>
              {plans.map(plan => (
                <td key={plan.id} className="px-6 py-4">
                  {feature.values[plan.id] === true ? (
                    <span className="text-green-600">✓</span>
                  ) : feature.values[plan.id] === false ? (
                    <span className="text-red-600">✗</span>
                  ) : (
                    feature.values[plan.id]
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlanComparison;